import { Box, Text } from '@wix/design-system';
import classNames from 'classnames';
import React from 'react';
import priceDataHooks from '../Price.datahooks';
import s from './DisplayPrice.scss';
export const DisplayPrice = ({ size, integer, fraction, currency, cycleLabel, }) => {
    const shouldShowFraction = fraction !== '00';
    return (React.createElement(Box, { className: classNames(s.displayPrice, s[size]), dataHook: priceDataHooks.displayPrice },
        React.createElement(Box, { className: classNames(s.currency, s[size]) },
            React.createElement(Text, { size: size, dataHook: priceDataHooks.currencySymbol }, currency)),
        React.createElement(Text, { className: classNames(s.integer, s[size]), dataHook: priceDataHooks.integerPrice }, integer),
        React.createElement(Box, { direction: "vertical", align: "space-between", className: classNames(s.fractionAndCycle), gap: "-2px" },
            React.createElement(Box, { className: classNames(s.fraction, s[size], {
                    [s.hidden]: !shouldShowFraction,
                }) },
                React.createElement(Text, { size: size, dataHook: priceDataHooks.fractionPrice }, fraction)),
            React.createElement(Box, { className: classNames(s.cycleLabel, s[size]) },
                React.createElement(Text, { size: size, dataHook: priceDataHooks.cycleLabel }, cycleLabel)))));
};
//# sourceMappingURL=DisplayPrice.js.map